// extracted by mini-css-extract-plugin
export default {"root":"LoginView_root__SDNdw","formWrapper":"LoginView_formWrapper__rBbQX","button":"LoginView_button__uWZrR"};